import { render, staticRenderFns } from "./MedicalRequirementsPlansTests.vue?vue&type=template&id=79fb2490&"
import script from "./MedicalRequirementsPlansTests.vue?vue&type=script&lang=js&"
export * from "./MedicalRequirementsPlansTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports